// extracted by css-extract-rspack-plugin
export default {"root":"root-obgRnw","boldText":"boldText-jukMZZ"};